export const CREDIT_AGENT_START = 'CREDIT_AGENT_START';
export const CREDIT_AGENT_ERROR = 'CREDIT_AGENT_ERROR';
export const CREDIT_AGENT_SUCCESS = 'CREDIT_AGENT_SUCCESS';
